module.exports = __webpack_public_path__ + "img/agence-02.80bfa99.jpg";